import MetaSelect from './index';
import { isDev } from '../../config';

/**
 * Select class for <select> in the hiring bloc
 */
export default class MetaHiringSelect extends MetaSelect {
  /**
   * Component configuration
   */
  get config() {
    return {
      name: 'HiringSelect',
      log: isDev(),
    };
  }

  /**
   * Mounted hook
   */
  afterMounted() {
    this.url = null;
    if (this.$refs.button) {
      this.$refs.button.addEventListener('click', this.buttonClickHandler);
    }
  }

  /**
   * Update the native Drupal <select> this.$refs.select
   * @param {string} value ElementUi Select component new value.
   * @see Select.vue to view the $emit function
   */
  updateChange(value) {
    this.url = value;
  }

  /**
   * Button Click Handler
   */
  buttonClickHandler() {
    if (this.url) {
      document.location = this.url;
    }
  }
}
